import BaseComponent from '../abstracts/BaseComponent';

export default class AccordionComponent extends BaseComponent {
  get SELECTORS() {
    return {
      triggers: '.js-accordion-trigger',
      content: '.js-accordion-content'
    };
  }

  get CLASSES() {
    return {
      active: 'is-active',
      visible: 'is-visible'
    };
  }

  constructor(props) {
    super(props);
    this.timeout = null;
    this.selectTabByUrl();
    this.handleClick();
  }

  async selectTabByUrl() {
    const { hash } = window.location;
    if (hash) {
      const currentTarget = document.querySelector(`[aria-controls="${hash.replace('#', '')}"]`);
      if (currentTarget) {
        const triggers = this.$el.querySelectorAll(this.SELECTORS.triggers);
        const contents = this.$el.querySelectorAll(this.SELECTORS.content);
        await this.closeOthers(currentTarget);
        this.open(currentTarget, triggers, contents);
      }
    }
  }

  /**
   *
   * @param {HTMLElement} element
   */
  closeOthers(element) {
    return new Promise((resolve, reject) => {
      try {
        const parent = element.parentElement;
        const parentSiblings = parent.parentElement.children;

        [...parentSiblings].forEach((el, index) => {
          if (el !== parent) el.classList.remove(this.CLASSES.visible);
          setTimeout(() => {
            if (el !== parent) el.classList.remove(this.CLASSES.active);
            if (index === parentSiblings.length - 1) {
              resolve();
            }
          }, 100);
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  open(currentTarget, triggers, contents) {
    const targetContent = this.$el.querySelector(`#${currentTarget.getAttribute('aria-controls')}`);
    const targetParent = currentTarget.parentElement;
    const active = targetParent.classList.contains(this.CLASSES.active);

    triggers.forEach(el => el.setAttribute('aria-expanded', 'false'));
    contents.forEach(el => el.setAttribute('aria-hidden', 'true'));

    currentTarget.setAttribute('aria-expanded', String(!active));
    targetContent.setAttribute('aria-hidden', String(!active));
    targetParent.classList[active ? 'remove' : 'add'](this.CLASSES.active);

    this.timeout = setTimeout(() => {
      targetParent.classList[active ? 'remove' : 'add'](this.CLASSES.visible);
    }, 100);
  }

  handleClick() {
    const triggers = this.$el.querySelectorAll(this.SELECTORS.triggers);
    const contents = this.$el.querySelectorAll(this.SELECTORS.content);

    triggers.forEach((trigger) => {
      this.$on('click.tabs', (e) => {
        e.preventDefault();
        const { currentTarget } = e;
        clearTimeout(this.timeout);
        this.closeOthers(currentTarget)
          .then(() => {
            this.open(currentTarget, triggers, contents);
          });
      }, trigger);
    });
  }
}
